import { Box, styled, Paper } from '@mui/material';
import color from 'src/theme/color';

export const QuestionsHeaderRow = styled(Box)<{ collapsible?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${({ collapsible }) => (collapsible ? '32px' : '0')};
`;

export const QuestionCard = styled(Paper)`
    width: 100%;
    margin-bottom: 16px;
    background-color: ${color.darkGray};
    border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;
`;

export const QuestionHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    cursor: pointer;
    user-select: none;
    &:hover {
        background-color: rgba(255, 255, 255, 0.03);
    }
`;

export const QuestionBody = styled(Box)`
    padding: 0 24px 24px;
`;
